import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import { firstToUpper } from "../../../../../../../utils/helpers/string";
import { RenderItem } from "./RenderItem";

const Schedule = ({ data }) => {
    const { t } = useTranslation();
    const { schedule, scheduleBinding } = data;

    return (
        <>
            <div className="tooltip-content-style text-left d-flex flex-column">
                <h3 className="font-weight-bolder text-left mb-0">{t("schedule")}</h3>
                {schedule?.shiftStart?.old !== undefined || schedule?.shiftStart?.new !== undefined ? (
                    <RenderItem
                        label="start-of-day"
                        oldValue={
                            schedule?.shiftStart?.old ? moment(schedule?.shiftStart?.old).format("hh:mm A") : "N/A"
                        }
                        newValue={
                            schedule?.shiftStart?.new ? moment(schedule?.shiftStart?.new).format("hh:mm A") : "N/A"
                        }
                    />
                ) : null}

                {schedule?.shiftEnd?.old !== undefined || schedule?.shiftEnd?.new !== undefined ? (
                    <RenderItem
                        label="end-of-day"
                        oldValue={
                            schedule?.shiftEnd?.old ? moment(schedule?.shiftEnd?.old).format("hh:mm A") : "N/A"
                        }
                        newValue={
                            schedule?.shiftEnd?.new ? moment(schedule?.shiftEnd?.new).format("hh:mm A") : "N/A"
                        }
                    />
                ) : null}

                {typeof schedule?.status?.new === "boolean" && (
                    <RenderItem
                        title="round-start"
                        label={firstToUpper("minutes")}
                        newStatus={schedule.status.new}
                        oldStatus={schedule.status.old}
                        newValue={schedule?.amount?.new}
                        oldValue={schedule?.amount?.old}
                    />
                )}

                {typeof scheduleBinding?.new?.shiftStart?.status === "boolean" && (
                    <RenderItem
                        title="shift-start-restriction"
                        label={firstToUpper("minutes")}
                        newStatus={scheduleBinding.new.shiftStart.status}
                        oldStatus={scheduleBinding.old.shiftStart.status}
                        newValue={scheduleBinding.new.shiftStart.value}
                        oldValue={scheduleBinding.old.shiftStart.value}
                    />
                )}

                {typeof scheduleBinding?.new?.shiftEnd?.status === "boolean" && (
                    <RenderItem
                        title="shift-end-restriction"
                        label={firstToUpper("minutes")}
                        newStatus={scheduleBinding.new.shiftEnd.status}
                        oldStatus={scheduleBinding.old.shiftEnd.status}
                        newValue={scheduleBinding.new.shiftEnd.value}
                        oldValue={scheduleBinding.old.shiftEnd.value}
                    />
                )}

                {typeof scheduleBinding?.new?.breakStart?.status === "boolean" && (
                    <RenderItem
                        title="break-start-restriction"
                        label={firstToUpper("minutes")}
                        newStatus={scheduleBinding.new.breakStart.status}
                        oldStatus={scheduleBinding.old.breakStart.status}
                        newValue={scheduleBinding.new.breakStart.value}
                        oldValue={scheduleBinding.old.breakStart.value}
                    />
                )}

                {typeof scheduleBinding?.new?.breakEnd?.status === "boolean" && (
                    <RenderItem
                        title="break-stop-restriction"
                        label={firstToUpper("minutes")}
                        newStatus={scheduleBinding.new.breakEnd.status}
                        oldStatus={scheduleBinding.old.breakEnd.status}
                        newValue={scheduleBinding.new.breakEnd.value}
                        oldValue={scheduleBinding.old.breakEnd.value}
                    />
                )}
            </div>
        </>
    );
};

export default Schedule;
